import React, { createContext, useState, useEffect } from 'react';
import { site_url } from "./config.js";
import { cachedGet } from './services/apiCacheService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Stores the logged-in user's token
  const [loading, setLoading] = useState(true); // To handle loading state
  const [vendordetails, setvendordetails] = useState(null); // Stores the logged-in user's token

  // Load user token from localStorage on app initialization
  useEffect(() => {
    const savedToken = localStorage.getItem('access_token');
    if (savedToken) {
      const parsedData = JSON.parse(savedToken);
      setUser(parsedData); // Set token as user
    }
    setLoading(false);
  }, []);

  // Login function to set user and token
  const login = (token) => {
    setUser(token);
    localStorage.setItem('access_token', token);
  };

  // Logout function to clear user and token
  const logout = () => {
    setUser(null);
    localStorage.removeItem('access_token');
  };

  const fetchUserData = async () => {
    const savedToken = localStorage.getItem('access_token');
    if (savedToken) {
      const parsedData = JSON.parse(savedToken);



      try {

        const responseData = await cachedGet(site_url + '/vendor/details/'+ parsedData.id);
        const response = { data: responseData };
        setvendordetails(response.data);
       
      
      } catch (error) {
        console.error('Error fetching user details:', error);
        setvendordetails(null);
      } finally {

      }
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, vendordetails, setvendordetails,refreshUser:fetchUserData }}>
      {children}
    </AuthContext.Provider>
  );
};
